import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
type Purchase = {
  name: string;
  city: string;
  minutesAgo: number;
};
const PURCHASES: Purchase[] = [{
  name: 'Pablo G.',
  city: 'Lima, Perú',
  minutesAgo: 3
}, {
  name: 'María L.',
  city: 'Ciudad de México, México',
  minutesAgo: 10
}, {
  name: 'Javier R.',
  city: 'Madrid, España',
  minutesAgo: 6
}, {
  name: 'Carolina M.',
  city: 'Bogotá, Colombia',
  minutesAgo: 2
}, {
  name: 'Andrés P.',
  city: 'Santiago, Chile',
  minutesAgo: 14
}, {
  name: 'Lucía F.',
  city: 'Buenos Aires, Argentina',
  minutesAgo: 5
}, {
  name: 'Diego S.',
  city: 'Guadalajara, México',
  minutesAgo: 8
}, {
  name: 'Valentina C.',
  city: 'Quito, Ecuador',
  minutesAgo: 1
}, {
  name: 'Roberto H.',
  city: 'Arequipa, Perú',
  minutesAgo: 12
}, {
  name: 'Sofía T.',
  city: 'Barcelona, España',
  minutesAgo: 4
}, {
  name: 'Camila N.',
  city: 'Medellín, Colombia',
  minutesAgo: 9
}, {
  name: 'Fernando D.',
  city: 'Monterrey, México',
  minutesAgo: 7
}, {
  name: 'Gabriela V.',
  city: 'Valencia, España',
  minutesAgo: 16
}, {
  name: 'Martín A.',
  city: 'Córdoba, Argentina',
  minutesAgo: 3
}, {
  name: 'Patricia E.',
  city: 'San José, Costa Rica',
  minutesAgo: 11
}, {
  name: 'Ricardo B.',
  city: 'Asunción, Paraguay',
  minutesAgo: 6
}, {
  name: 'Daniela Q.',
  city: 'Montevideo, Uruguay',
  minutesAgo: 2
}, {
  name: 'José M.',
  city: 'Cusco, Perú',
  minutesAgo: 18
}, {
  name: 'Elena R.',
  city: 'Sevilla, España',
  minutesAgo: 5
}, {
  name: 'Antonio L.',
  city: 'Puebla, México',
  minutesAgo: 13
}];
const VISIBLE_MS = 3500;
const INTERVAL_MS = 10000;
export const SocialProofPopup = () => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const showOne = () => {
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), VISIBLE_MS);
    };
    const firstShow = setTimeout(showOne, 2000);
    const cycle = setInterval(() => {
      setIndex(prev => (prev + 1) % PURCHASES.length);
      showOne();
    }, INTERVAL_MS);
    return () => {
      clearTimeout(firstShow);
      clearTimeout(hideTimer);
      clearInterval(cycle);
    };
  }, []);
  const purchase = PURCHASES[index];
  return <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[100] w-[92%] max-w-sm pointer-events-none" data-id="element-263">
      <AnimatePresence mode="wait" data-id="element-264">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        y: -24
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -24
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} role="status" aria-live="polite" className="pointer-events-auto bg-familia-card border border-familia-gold/40 rounded-xl shadow-[0_10px_30px_-10px_rgba(0,0,0,0.6)] p-3 flex items-start gap-3" data-id="element-265">
            <span className="text-2xl shrink-0" aria-hidden="true" data-id="element-266">
              🛒
            </span>
            <div className="text-left" data-id="element-267">
              <p className="text-sm font-bold text-white leading-tight" data-id="element-268">
                {purchase.name}{' '}
                <span className="text-familia-gray font-normal" data-id="element-269">
                  de {purchase.city}
                </span>
              </p>
              <p className="text-[12px] text-familia-gray leading-tight" data-id="element-270">
                adquirió el kit hace {purchase.minutesAgo}{' '}
                {purchase.minutesAgo === 1 ? 'minuto' : 'minutos'}
              </p>
              <p className="text-[11px] font-semibold text-familia-gold leading-tight mt-0.5 flex items-center gap-1" data-id="element-271">
                <span aria-hidden="true" data-id="element-272">⭐⭐⭐⭐⭐</span> Compra verificada
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};